import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPatchDepositRuleRequestSchema,
  TPatchDepositRuleResponseSchema,
} from "./patchDepositRule.schema";

export const patchDepositRule = (axios: IAxiosInstance) => {
  return async (data: TPatchDepositRuleRequestSchema) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TPatchDepositRuleResponseSchema>
    >(`/api/deposit-rules/${data.ruleID}`, data);

    return response.data;
  };
};
